import { useEffect } from "react";

const LinkedInInsight = () => {
  useEffect(() => {
    const partnerId = "7222348";

    // Initialize the LinkedIn data partner ID
    (window as any)._linkedin_data_partner_ids = (window as any)._linkedin_data_partner_ids || [];
    (window as any)._linkedin_data_partner_ids.push(partnerId);

    // Avoid injecting the script multiple times
    if (!document.getElementById("linkedin-insight-script")) {
      const script = document.createElement("script");
      script.type = "text/javascript";
      script.async = true;
      script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
      script.id = "linkedin-insight-script";

      const firstScript = document.getElementsByTagName("script")[0];
      firstScript?.parentNode?.insertBefore(script, firstScript);
    }
  }, []);

  return (
    <noscript>
      <img
        height="1"
        width="1"
        style={{ display: "none" }}
        alt=""
        src="https://px.ads.linkedin.com/collect/?pid=7222348&fmt=gif"
      />
    </noscript>
  );
};

export default LinkedInInsight;